/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pesticide_SupplierInputs */

const vi_pesticide_supplier = /** @type {(inputs: Pesticide_SupplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị cung cấp`)
};

/**

* @param {Pesticide_SupplierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pesticide_supplier = /** @type {((inputs?: Pesticide_SupplierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pesticide_SupplierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pesticide_supplier(inputs)
});